// extracted by mini-css-extract-plugin
module.exports = {"card":"favorites_card_3nHsM","body":"favorites_body_Gf9j3"};